export default __webpack_public_path__ + "static/loading-732ad918c63dc539def6c5821dfa3196.gif";